import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * HTTP Interceptor that transforms filter form URLs to use forward slashes
 * instead of encoded backslashes (%5C) to work around Traefik security restrictions.
 *
 * Transforms:
 *   /api/ext/filter/form/App%5CEntity%5CJobCard%5CTask/App%5CEntity%5CFilters%5CWorkerReport%5CWorkerReportFilter
 * To:
 *   /api/ext/filter/form/App/Entity/JobCard/Task--App/Entity/Filters/WorkerReport/WorkerReportFilter
 */
@Injectable()
export class FilterUrlInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only transform filter form URLs
        if (req.url.includes('/api/ext/filter/form/')) {
            const transformedUrl = this.transformFilterUrl(req.url);
            if (transformedUrl !== req.url) {
                req = req.clone({ url: transformedUrl });
            }
        }
        return next.handle(req);
    }

    private transformFilterUrl(url: string): string {
        // Match the filter form URL pattern
        const filterFormPattern = /\/api\/ext\/filter\/form\/([^/]+)(\/([^/]+))?/;
        const match = url.match(filterFormPattern);

        if (!match) {
            return url;
        }

        // Decode the URL-encoded class name and slug
        const className = decodeURIComponent(match[1]);
        const slug = match[3] ? decodeURIComponent(match[3]) : null;

        // Convert backslashes to forward slashes
        const classWithSlashes = className.replace(/\\/g, '/');

        // Build the new URL with -- separator if there's a slug
        let newPath: string;
        if (slug) {
            const slugWithSlashes = slug.replace(/\\/g, '/');
            newPath = `/api/ext/filter/form/${classWithSlashes}--${slugWithSlashes}`;
        } else {
            newPath = `/api/ext/filter/form/${classWithSlashes}`;
        }

        // Replace the path portion of the URL, preserving query string
        return url.replace(filterFormPattern, newPath);
    }
}
